import { render, staticRenderFns } from "./newRoleModal.vue?vue&type=template&id=723134dc&scoped=true&"
import script from "./newRoleModal.vue?vue&type=script&lang=js&"
export * from "./newRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./newRoleModal.vue?vue&type=style&index=0&id=723134dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723134dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDialog})
